// Slick Slider for .customslick__slider
$('.video-image-slider-wrapper').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
   autoplay: true,
   autoplaySpeed: 2000,
  speed: 1000,  // Adjust speed for smooth transition
  cssEase: 'ease',  // Use 'ease' for a smooth sliding effect
  arrows: true,
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         autoplay: true,
        autoplaySpeed: 2000,
        speed: 1000,  // Adjust speed for smooth transition
        cssEase: 'ease',  // Use 'ease' for a smooth sliding effect
        infinite: true,
        dots: false,
        arrows: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         autoplay: true,
        autoplaySpeed: 2000,
        speed: 1000,  // Adjust speed for smooth transition
        cssEase: 'ease',  // Use 'ease' for a smooth sliding effect
        dots: false,
        arrows: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 2000,
        speed: 1000,  // Adjust speed for smooth transition
        pauseOnHover: true,
        cssEase: 'ease',  // Use 'ease' for a smooth sliding effect
        dots: false,
        arrows: true,
      }
    }
  ]
});

// Slick Slider for .customslick__slider
$('.image-text-carousel').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
   autoplay: true,
   autoplaySpeed: 2000,
  speed: 1000,  // Adjust speed for smooth transition
  cssEase: 'ease',  // Use 'ease' for a smooth sliding effect
  arrows: true,
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         autoplay: true,
        autoplaySpeed: 2000,
        speed: 1000,  // Adjust speed for smooth transition
        cssEase: 'ease',  // Use 'ease' for a smooth sliding effect
        infinite: true,
        dots: false,
        arrows: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         autoplay: true,
        autoplaySpeed: 2000,
        speed: 1000,  // Adjust speed for smooth transition
        cssEase: 'ease',  // Use 'ease' for a smooth sliding effect
        dots: false,
        arrows: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 2000,
        speed: 1000,  // Adjust speed for smooth transition
        pauseOnHover: true,
        cssEase: 'ease',  // Use 'ease' for a smooth sliding effect
        dots: false,
        arrows: true,
      }
    }
  ]
});

